export enum deviceTypeCategory {
  legacyClient = 1,
  legacyHost = 2,
  skyTankGateway = 3,
  skyTankSensor = 4,
  other = 0,
  radar = 5
}
